// Hesap API'si için küçük yardımcılar. Oturum, tarayıcıdan okunamayan bir çerezde tutulur.
import { useCallback, useEffect, useState } from 'react';
import type { MeResponse } from '../../shared/plans';

export async function api<T>(path: string, options: { method?: string; body?: unknown } = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetch(path, {
      method: options.method ?? 'GET',
      headers: options.body === undefined ? undefined : { 'Content-Type': 'application/json' },
      body: options.body === undefined ? undefined : JSON.stringify(options.body),
    });
  } catch {
    throw new Error('Sunucuya ulaşılamadı.');
  }
  const data = (await res.json().catch(() => ({}))) as T & { error?: string };
  if (!res.ok) throw new Error(data.error ?? `İstek başarısız (HTTP ${res.status}).`);
  return data;
}

export function useMe() {
  const [me, setMe] = useState<MeResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const refresh = useCallback(() => {
    setError(null);
    return api<MeResponse>('/api/auth/me').then(setMe, (err: Error) => setError(err.message));
  }, []);
  useEffect(() => {
    void refresh();
  }, [refresh]);
  return { me, error, refresh };
}

export const logout = () => api('/api/auth/logout', { method: 'POST' });
